import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play-circle",
  "use": "icon-play-circle-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-play-circle\">\n<path d=\"M6,11c2.8,0,5-2.3,5-5S8.8,1,6,1S1,3.2,1,6S3.2,11,6,11z M6,12c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S9.3,12,6,12z M4.2,2.6\n\tL9,6L4.2,9.4V2.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/play-circle.svg
// module id = 158
// module chunks = 0 1 2